import cn from 'classnames'

import ReactHtmlParser from 'react-html-parser'

import styles from './styles.module.scss'
import OpenIcon from './icons/iconOpen.svg'
import CloseIcon from './icons/iconClose.svg'
import { ExchangeQuestionProps } from './exchange-question.props'
import { useTranslation } from 'utils/use-translation'

export default function ExchangeQuestion({ currentId, questionId, handleOpen, question }: ExchangeQuestionProps) {
  const { t } = useTranslation()

  return (
    <div className={styles.question}>
      <div
        className={cn(styles.question__title, { [styles.question__title_opened]: currentId === questionId })}
        onClick={handleOpen}
      >
        <h5>{t(question.title)}</h5>
        <img src={currentId === questionId ? OpenIcon : CloseIcon} alt="eye icon" />
      </div>
      <p className={cn(styles.text, { [styles.opened]: currentId === questionId })}>
        {ReactHtmlParser(t(question.answer))}
      </p>
    </div>
  )
}
